<template>
  <d-modal-confirmation
    :title="modalTitle"
    :text="modalConfirmationText"
    :modal="modal"
    :submitButtonText="modalSubmitButtonText"
    @closeModal="handleCloseModal"
    @submitModal="handleSubmitModal"
    :isSubmitting="isSubmitting"
  >
  </d-modal-confirmation>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    modalTitle() {
      return this.$t("tags.tag.change-status.title", {
        action: this.item.isActive
          ? this.$t(`tags.tag.change-status.button.deactivate`)
          : this.$t(`tags.tag.change-status.button.activate`),
      });
    },
    modalConfirmationText() {
      return this.$t("tags.tag.change-status.text", {
        action: this.item.isActive
          ? this.$t(`tags.tag.change-status.button.deactivate`).toLowerCase()
          : this.$t(`tags.tag.change-status.button.activate`).toLowerCase(),
        displayName: this.item.displayName,
      });
    },
    modalSubmitButtonText() {
      return this.item.isActive
        ? this.$t(`tags.tag.change-status.button.deactivate`)
        : this.$t(`tags.tag.change-status.button.activate`);
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },
    handleSubmitModal() {
      this.item.isActive ? this.deactivateTag() : this.activateTag();
    },
    activateTag() {
      this.isSubmitting = true;
      window.API.activateTag(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("tags.tag.change-status.alert.activated", {
              displayName: this.item.displayName,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t("tags.tag.change-status.alert.could-not-activate"),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    deactivateTag() {
      this.isSubmitting = true;
      window.API.deactivateTag(this.item.id)
        .then(() => {
          this.$eventBus.$emit("notification", {
            type: "success",
            message: this.$t("tags.tag.change-status.alert.deactivated", {
              displayName: this.item.displayName,
            }),
          });
          this.$emit("submitModal");
          this.handleCloseModal();
        })
        .catch(() => {
          this.$eventBus.$emit("notification", {
            type: "error",
            message: this.$t(
              "tags.tag.change-status.alert.could-not-deactivate"
            ),
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
